/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Run_Error_Message_DeadInputs */

const en_sync_run_error_message_dead = /** @type {(inputs: Sync_Run_Error_Message_DeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The message could not be delivered: Nexxt gave up after a day of attempts. See the integration errors, then send again.`)
};

/**
* | output |
* | --- |
* | "The message could not be delivered: Nexxt gave up after a day of attempts. See the integration errors, then send again." |
*
* @param {Sync_Run_Error_Message_DeadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_run_error_message_dead = /** @type {((inputs?: Sync_Run_Error_Message_DeadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Run_Error_Message_DeadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_run_error_message_dead(inputs)
});